import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import { PersonSearchService } from '../_services/person-search.service';
import * as _ from 'underscore';
import { LocalStorageService } from '../_services/local-storage.service';
import { SimilarCandidateService } from '../_services/similar-candidate.service';
import { GlobalService } from '../_services/global.service';
import { ActivatedRoute } from '@angular/router';
import { AiSourcingService } from '../_services/ai-sourcing.service';
import { AegisIntegrationService } from '../_services/aegisIntegration.service';
import { Subscription } from 'rxjs';
declare const clevertap;
@Component({
    selector: 'app-person-search-candidate-slider',
    templateUrl: './person-search-candidate-slider.component.html',
    styleUrls: ['./person-search-candidate-slider.component.scss'],
    standalone: false
})
export class PersonSearchCandidateSliderComponent implements OnInit {
  public revealableInfo: { key: string, text: string, data?: string | string[], can_reveal: boolean, icon: string, is_revealed?: boolean }[] = [];
  clonedExperience: any;
  currentCompanyInformation: any = {};

  get hasRevealableInfo() {
    return this.revealableInfo.length > 0;
  }

  get hasWorkEmail() {
    return !!(this.data.work_email && this.data.work_email.length);
  }

  get hasPersonalEmail() {
    return !!(this.data.personal_email && this.data.personal_email.length);
  }

  constructor(
    private datePipe: DatePipe,
    private personSearchService: PersonSearchService,
    private localstorageservice: LocalStorageService,
    private similarCandidateService: SimilarCandidateService,
    private route: ActivatedRoute,
    public aiSourcingService: AiSourcingService,
    private aegisIntegrationService: AegisIntegrationService
  ) { }
  @Input() data: any = null;
  @Input() currentIndex: any;
  @Input() highlightkeywords;
  @Input() parent: string = null;
  @Input() isAegisConnected: boolean = false;
  experience: any;
  formattedSkills: any;
  currentSchool: any;
  currentJobTitle: any;
  currentCompany: any;
  currentLocation: any;
  currentStartDate: any;
  currentTenure: any;
  totalTenure: any;
  uniqueProfiles: any = {};
  linkedin_url: any = null;
  facebook_url: any = null;
  twitter_url: any
  github_url: any
  stackoverflow_url: any
  behance_url: any
  dribbble_url: any
  medium_url: any
  quora_url: any

  profileTab: boolean = true
  contactTab: boolean = false
  similarTab: Boolean = false
  activityTab: Boolean = false
  documentTab: Boolean = false


  @Output() childEvents = new EventEmitter<{ action: string, data: any, index: any }>();
  @Output() candidateExistInAegis = new EventEmitter<any>();
  @Input() tabType;
  totalresultcount: any;
  similarcandidates: any[] = [];
  totalCandidatesCountLoading: Boolean = false;

  isProfileTabCalled: boolean = false;
  issimilartabshow: boolean = false;
  lastUpdatedExpDate: string;
  jobLastVerifiedDate: string;
  @Input() viewMoreSkills: boolean = false;

  /**array of social icons */
  socialIcons: any[] = [];
  currentUrl: string;
  showFullText: boolean = true;
  successMessage: string = '';
  errorMessage: string = '';
  @Input() calledfrompage: string;
  autopilotTab:boolean=false
  screenTab:Boolean=false


  /** Array of Highlights List */
  highlightsList: any[] = [];

  /**
   * Autopilot PDF Export In progres
   */
  autopilotPdfExportInPrgoress: boolean = false;
  @Output() revealStatusEventEmitter: EventEmitter<any> = new EventEmitter();

  aegisCandidateData: any = null;
  subscriptions: Array<Subscription> = [];

  ngOnInit(): void {

    const getAegisCandidateData = this.aegisIntegrationService.getAegisTagCandidateEvent.subscribe(res => {
      if (res) {
        this.aegisCandidateData = res.taggedCandidate;
      } else {
        this.aegisCandidateData = null;
      }
    });
    this.subscriptions.push(getAegisCandidateData);

    if (this.isAegisConnected) {
      this.checkCadidateExistInAegis(this.data);
    };

    this.currentUrl = window.location.href;
    /**Handled If job will imported from any ATS don't show profile tab */
    if (this.calledfrompage == 'resume-screen' && this.data?.jobsource == 'import') {
      this.onTabChange('document');
    };

    this.highlightsList = this.getTierOneCompanyAndSchoolHilights(this.data?.curatedtalentpooltags);
    if(this.tabType == 'profileTab'){
      this.saveProfileView();
    } else if (this.tabType == 'contactTab') {
      this.contactTab = true;
      this.profileTab = false
      this.autopilotTab = false;
      this.screenTab = false;

      this.saveProfileView('contact');
    } else if (this.tabType == 'activityTab') {
      this.activityTab = true;
      this.profileTab = false;
      this.autopilotTab = false;
      this.screenTab = false;

    }else if (this.tabType == 'autopilotTab') {
      this.activityTab = false;
      this.profileTab = false;
      this.autopilotTab = true;
      this.screenTab = false;

    }else if (this.tabType == 'screenTab') {
      this.activityTab = false;
      this.profileTab = false;
      this.autopilotTab = false;
      this.screenTab = true;
    }
    this.isProfileTabCalled = false;

    // Not to call similar candidates API when called from screenai
    if(this.calledfrompage != 'resume-screen'){
      this.getsimilarcandidatesData()
    }
    this.buildData();
    this.getSocialIcons();
    /**
        * Profile viewed CT event
        */
    const profileParams = {
      "User ID": this.localstorageservice.getItem('userdata').userid,
      "Candidate ID": this.data.id,
      "Timestamp": moment().format()
    }
    clevertap.event.push('Profile Viewed', profileParams);
  }

  /**
   * Check if candidate exist in Aegis
   */
  checkCadidateExistInAegis(data: any) {

    const payload = {
      "personalemail": data.personalemail,
      "personalmobile": data.personalmobile,
      "firstname": data.first_name,
      "lastname": data.last_name,
      "jobtitle": data.job_title,
      "currentcompany": data.job_company_name,
      "linkedin": data.linkedin_url 
    };

    this.aegisIntegrationService.checkCandidateExistInAegis(payload).subscribe((res: any) => {
      if (res && res.body && res.body?.success && res.body.data && res.body.data.status === 'success') {
        this.aegisCandidateData = res.body.data.data; 
        this.candidateExistInAegis.emit(this.aegisCandidateData);
      } else {
        this.aegisCandidateData = null;
        this.candidateExistInAegis.emit(this.aegisCandidateData);
      };
    }, (err) => {
      this.aegisCandidateData = null;
      this.candidateExistInAegis.emit(this.aegisCandidateData);
    });
  };

  /**
   * Format date in required format
   * @param dateString 
   * @returns 
   */
  getFormatedDate(dateString: string) {
    const date = GlobalService.getDates(dateString);
    return date;
  };

  toggleView() {
    this.showFullText = !this.showFullText;
  }


  private getTierOneCompanyAndSchoolHilights(curatedtalentpooltags: any[]) {
    const highlightsFormatedData: any[] = [];
    const grouped: Record<string, any> = {};

    if (this.data?.highlightsPillData.fetchTalentIndustries && this.data?.highlightsPillData.fetchTalentIndustries.length) {
      grouped['fetchTalentIndustries'] = { label: "Multi-Industry", value: this.data?.highlightsPillData.fetchTalentIndustries, color: "blue", imageName: "multi-industry" }
    }

    if (this.data?.highlightsPillData.fetchUnicornCompanies && this.data?.highlightsPillData.fetchUnicornCompanies.length) {
      grouped['fetchUnicornCompanies'] = { label: "Unicorn Experience", value: this.data?.highlightsPillData.fetchUnicornCompanies, color: "yellow", imageName: "unicorn-experience" }
    }

    if (this.data?.highlightsPillData?.isTechie) {
      grouped['isTechie'] = { label: "Techie", value: this.data?.highlightsPillData.isTechie, color: "green", imageName: "techie" }
    }

    if (this.data?.currentjob_internal_movement || this.data?.progression_within_pastcompany) {
      grouped['PromotionTrack'] = { label: "Promotion Track", value: { currentjob_internal_movement: this.data?.currentjob_internal_movement, progression_within_pastcompany: this.data?.progression_within_pastcompany }, color: "yellow", imageName: "promotion-track" }
    }

    if (this.data?.highlights?.locationNames) {
      grouped['SameLocation'] = { label: "Same Location", value: this.data?.highlights?.locationNames, color: "green", imageName: "same-location" }
    }

    if (this.data?.highlights?.regionname) {
      grouped['NearbyLocation'] = { label: "Nearby Location", value: this.data?.highlights?.regionname, color: "green", imageName: "same-location" }
    }

    if (this.data?.highlights?.titles) {
      grouped['RoleCompatibility'] = { label: "Role Compatibility", value: this.data?.highlights?.titles, color: "title", imageName: "role-compatibility" }
    }

    if (this.data?.highlights?.totalTenure) {
      grouped['YearsOfExperience'] = { label: "Years of Experience", value: this.data?.highlights?.totalTenure, color: "yearsofexp", imageName: "years-of-experience" }
    }

    if (this.data?.highlights?.companySizes) {
      grouped['CompanySize'] = { label: "Company Size", value: this.data?.highlights?.companySizes, color: "pink", imageName: "company-size" }
    }

    if (this.data?.highlights?.skills) {
      grouped['SkillsMatched'] = { label: "Skills Matched", value: this.data?.highlights?.skills, color: "skills", imageName: "skills-matched" }
    }

    const displayNameConfig: any = {
      "maang": { label: "MAANG", color: "maang", imageName: "maang" },
      "dax 40": { label: "DAX 40", color: "dax", imageName: "dax40" },
      "nasdaq 100": { label: "NASDAQ 100", color: "nasdaq", imageName: "nasdaq100" },
      "nifty 50 / sensex": { label: "Nifty 50 / Sensex", color: "nifty", imageName: "nifty50" },
      "fortune-500 us": { label: "Fortune Global 500", color: "fortuneGlobal", imageName: "fortuneglobal500" },
      "s&p 500": { label: "S&P 500", color: "sp", imageName: "sp500" },
      "big four": { label: "Big 4", color: "bigfour", imageName: "big4" },
      "dow 30": { label: "DOW 30", color: "dow", imageName: "dow30" },
      "fortune-500": { label: "Fortune 500", color: "fortune", imageName: "fortune500" },
      "big oil": { label: "Big Oil", color: "bigoil", imageName: "bigoil" },
      "ftse 100": { label: "FTSE 100", color: "ftse", imageName: "ftse100" },
      "u15 group (canada)": { label: "U15 Group (Canada)", color: "u15group", imageName: "u15" },
      "batx": { label: "BATX", color: "batx", imageName: "batx" },

      "tier-1 school": { label: "Tier-1 School", color: "teal", imageName: "tier1school" },
      "c9 league (china)": { label: "C9 League (China)", color: "c9League", imageName: "c9" },
      "ivy league (usa)": { label: "Ivy League (USA)", color: "ivy", imageName: "ivy" },
      "group of eight (australia)": { label: "Group of Eight (Australia)", color: "navy", imageName: "go8" },
      "russell group (uk)": { label: "Russell Group (UK)", color: "groupOfEight", imageName: "russell" },
    };


  if(curatedtalentpooltags && curatedtalentpooltags?.length){
    for (let el of curatedtalentpooltags) {
      if (!el?.displayname || !el?.name) continue;

      const key = el.displayname.toLowerCase().trim();
      const config = displayNameConfig[key];
      if (!config) continue;

      if (!grouped[key]) {
        grouped[key] = {
          id: Object.keys(grouped).length + 1,
          label: config.label,
          value: [],
          color: config.color,
          imageName: config.imageName
        };
      }

      if (!grouped[key].value.includes(el.name)) {
        grouped[key].value.push(el.name);
      }
    }
  }
    return Object.values(grouped);
  }




  /**
 * Handles all child events
 * @param action type of action
 * @param event Evenet
 */
  handleChildEvents(action: string, event?: Event) {
    this.childEvents.emit({ action: action, data: { ...this.data, selected: event ? (event.target as HTMLInputElement).checked : this.data.selected }, index: null })
  }

  /**
 * Determines if candidate has highlight information to display
 * @returns {boolean} True if candidate has valid highlight data (either in highlightsPillData or highlights objects)
 */
  get hasHighlightsToShow(): boolean {
    return (
      (this.data.highlightsPillData && (
        this.data.highlightsPillData.techie ||
        this.data.highlightsPillData.talentIndustries?.length > 0 ||
        this.data.highlightsPillData.unicornCompanies?.length > 0 ||
        this.data.highlightsPillData.fortuneFHCompanies?.length > 0 ||
        this.data.highlightsPillData.tierOneSchools?.length > 0
      )) ||
      (this.data.highlights && Object.keys(this.data.highlights).length > 0)
    );
  }

  closeNav() {
    this.handleChildEvents('closeNav')
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'block'

  }
  private pushRevealableInfo(key: string, text: string, data: string | string[], can_reveal: boolean = true, icon: string = 'fas fa-briefcase', is_revealed?: boolean) {
    if (data && Array.isArray(data) && data.length) {
      data = data.filter(d => d && d.length);
    }
    if (data && typeof data === 'string' && data.length) {
      data = [data];
    }
    data && data.length && this.revealableInfo.push({
      key,
      text,
      data,
      can_reveal,
      icon,
      is_revealed
    });
  }

  private capitalizeFirstLetter(string) {
    if (typeof string !== 'string' || string.length === 0) {
      return '';
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  }


  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  openUrl(link, type) {
    if (!link || !type)
      return;
    if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
      link = "https://" + link;
    else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
      link = "https://www." + link;
    else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
      link = "https://www." + link;
    else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
      link = "https://www." + link;
    else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
      link = "https://www." + link;
    else if (type == 'website') {
      link = "https://www." + link;
    }
    window.open(link, "_blank")
  }

  viewmoredetails(data, type) {
    if (type == 'viewmore') {
      document.getElementById(data + '_less').style.display = 'none'
      document.getElementById(data + '_more').style.display = 'block'
    } else {
      document.getElementById(data + '_less').style.display = 'block'
      document.getElementById(data + '_more').style.display = 'none'
    }
  }

  isBoolean(value: any) {
    if (typeof value == 'boolean' || value == 'true') {
      return true;
    }
    return false;
  }

  transform(value: string | string[]): string {
    if (!value) {
      return '';
    }

    if (Array.isArray(value)) {
      value = value[0] || '';
    }

    const regex = /(<.*?>)?([^<>]+)/g;
    const transformedValue = value?.replace(regex, (match, htmlTag, text) => {
      if (text) {
        const transformedText = text?.toLowerCase().replace(/\b\w/g, char => char?.toUpperCase());
        const result = htmlTag ? `${htmlTag}${transformedText}` : transformedText;
        return result;
      }
      return match;
    });

    return transformedValue;
  }

  checkIfProfessionalEmailAvailable(emails) {
    if (emails && emails.length) {
      return emails.filter(x => x.type == 'professional').length
    }
    return false
  }

  formatDate(dateString: string): string {
    if (dateString == null || dateString == 'null') {
      return '';
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      // If the date is not valid, or it's just a year (e.g., "2014")
      // then we return it as it is.
      return dateString;
    } else if (dateString && dateString.length === 4) {
      // If the date string contains only the year (e.g., "2014"),
      // we format it as "YYYY" (e.g., "2014")
      return this.datePipe.transform(date, 'yyyy');
    } else {
      // If it's a full date, we format it as "MMMM yyyy" (e.g., "January 2014")
      return this.datePipe.transform(date, 'MMMM yyyy');
    }
  }


  buildData() {
    this.currentLocation = this.data.location_name; //? this.data.location_name : this.data.location_names && this.data.location_names.length ? this.data.location_names[0] : null;
    this.isProfileTabCalled = true

    this.data.experience = this.data.experience.map((obj, index) => {
      const startDate = moment(obj.start_date);
      const endDate = moment(obj.end_date || new Date());
      const totalTenure = endDate.diff(startDate, 'years', true);
      obj.totaltenure = this.getFormattedTenure(totalTenure);

      if (obj.is_primary === true || obj.is_primary === 'true') {
        this.currentJobTitle = obj?.title?.name;
        this.currentCompany = obj?.company?.name;
        this.currentTenure = obj?.totaltenure;
        this.currentStartDate = startDate;
      }
      obj.expsummary = obj.summary;
      obj.index = index;
      obj.formattedExpSummary = GlobalService.getFormattedParagraph({ text: obj.expsummary, viewmode: 'less' });
      return obj;
    })

    const companyObjects = _.pluck(this.data.experience, 'company');
    const companyLogoPayload = companyObjects.map(x => {
      if (x.id || x.name) {
        return {
          ...(x.id && { id: x.id }),
          ...(x.name && { name: x.name })
        }
      }
    }).filter(Boolean);

    companyLogoPayload?.length &&
      this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((res: any) => {
        if (res && res.status == "success") {
          const resultName = res.data
          resultName.forEach(obj => {
            const matchingObj = this.data.experience.filter((item) => {
              return (obj.searchedVia === 'id' && obj.key === item.company.id) || ((obj.searchedVia === 'name') && (obj.key === item.company.name))
            });
            if (matchingObj && matchingObj.length) {
              let companyLogo = obj.companylogo
              matchingObj.forEach(x => {
                x.companylogo = companyLogo;
              })

            }
          });

        }
      })

    let expdetails = _.sortBy(this.data.experience, "is_primary==true");
    if (expdetails != undefined) {
      this.data.experience = _.where(expdetails, { is_primary: true });
      this.data.experience = this.data.experience.concat(
        _.reject(expdetails, { is_primary: true })
      );
    } else {
      this.data.experience = _.sortBy(this.data.experience, "startdate");
      this.data.experience = this.data.experience.reverse();
    }

    this.clonedExperience = this.data.experience.filter(obj => obj.is_primary != true && obj.is_primary != 'true');

    // if(this.clonedExperience && this.clonedExperience.length){
    //   if(this.currentLocation == null){
    //     this.currentLocation = this.clonedExperience[0].company.location.name
    //   }
    // }

    if (this.clonedExperience && this.clonedExperience.length) {
      if (this.currentJobTitle == null) {
        this.currentJobTitle = this.clonedExperience[0].title.name;
      }
      if (this.currentCompany == null) {
        this.currentCompany = this.clonedExperience[0].company.name;
      }
      if (this.currentTenure == null) {
        this.currentTenure = this.clonedExperience[0].totaltenure;
      }


    }

    this.linkedin_url = this.data.linkedin_url

    // enter the revealable info here
    this.pushRevealableInfo('personal_email', 'Personal Email', this.data.personal_emails, true, 'fas fa-briefcase');
    this.pushRevealableInfo('work_email', 'Professional Email', this.data.work_email, true, 'fas fa-envelope');
    this.pushRevealableInfo('mobile_phone', 'Phone Number', this.data.mobile_phone, true, 'fas fa-phone');

    this.totalTenure = this.getFormattedTenure(this.data.totaltenure);
    this.formattedSkills = this.data.skills.map(skill => `${skill.replace(/<\/?em>/g, '')}`).map(skill => skill.replace(/\b\w/g, match => match.toUpperCase()));
    // console.log(this.formattedSkills, 'formattedSkillsformattedSkills')
    this.data.education = this.data.education.map(obj => {
      if (!(obj.degrees && obj.degrees.length)) {
        if (obj.majors && obj.majors.length) {
          obj.newField = obj.majors[0];
          return obj;
        }
        return obj;
      }

      if (obj.degrees && obj.degrees.length) {
        let degreeWords = obj.degrees[0].split(' ');
        if (degreeWords.length > 2) {
          obj.newField = obj.degrees[0];
        } else {
          let position = 0;
          for (let i = 1; i < obj.degrees.length; i++) {
            degreeWords = obj.degrees[i].split(' ');
            position = i;
            if (degreeWords.length > 2) {
              obj.newField = obj.degrees[i];
              return obj;
            }
          }
          if (obj.majors && obj.majors.length) {
            obj.newField = degreeWords[position] + ' in ' + obj.majors[0];
          }
        }
        if (!obj.newField) obj.newField = obj.degrees.toString().trim().replace(/'/g, "''");
        return obj;
      }
      return obj;
    });

    const clonedEducation = this.data?.education?.length ? this.data?.education[0] : null;
    if (clonedEducation) {
      this.currentSchool = clonedEducation?.school?.name
    };

    const lastSeenexp = _.sortBy(this.data.experience, "last_seen").reverse();
    // this.lastUpdatedExpDate = GlobalService.getUpdateDates(lastSeenexp[0].last_seen).text;
    this.jobLastVerifiedDate = this.data.job_last_verified ? GlobalService.getUpdateDates(this.data.job_last_verified).text : this.data.job_last_verified

  }

  onTabChange(tab) {
    // if (this.data?.calledfrompage == 'reviewpage') return;
    this.viewMoreSkills = false;
    // const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    // //loadn[0].style.display = 'block'
    if (tab == 'profile') {
      this.profileTab = true
      this.contactTab = false
      this.similarTab = false
      this.activityTab = false;
      this.documentTab = false;
      this.autopilotTab= false;
      this.screenTab = false
      this.buildData();
      this.saveProfileView('profile');
    } else if (tab == 'contact') {
      this.profileTab = false
      this.contactTab = true
      this.similarTab = false
      this.activityTab = false;
      this.autopilotTab= false;
      this.screenTab = false
      //   //loadn[0].style.display = 'none'
      this.saveProfileView('contact');
    }
    else if (tab == 'similarcandidates') {
      this.profileTab = false
      this.contactTab = false
      this.similarTab = true;
      this.activityTab = false;
      this.autopilotTab= false;
      this.screenTab = false
      this.saveProfileView('similarcandidates');
    } else if (tab === 'activity') {
      this.profileTab = false
      this.contactTab = false
      this.similarTab = false;
      this.activityTab = true;
      this.autopilotTab= false;
      this.screenTab = false


    } else if (tab === 'document') {
      this.profileTab = false
      this.contactTab = false
      this.similarTab = false;
      this.activityTab = false;
      this.documentTab = true;
      this.autopilotTab= false;
      this.screenTab=false;

    } else if (tab === 'autopilot') {
      this.profileTab = false
      this.contactTab = false
      this.similarTab = false;
      this.activityTab = false;
      this.documentTab = false;
      this.autopilotTab= true;
      this.screenTab=false

    } else if (tab === 'screen') {
      this.profileTab = false
      this.contactTab = false
      this.similarTab = false;
      this.activityTab = false;
      this.documentTab = false;
      this.autopilotTab= false;
      this.screenTab = true
    }
    else {
      // add another condition if required
    }
  }


  eventHandler(event) {
    this.data = event.data;
    this.childEvents.emit({ action: 'append-data', data: event.data, index: this.currentIndex })

  }

  /**
   * Save profile view activity log
   * @param tabName
   */
  saveProfileView(tabName: "profile" | "contact" | "similarcandidates" = "profile") {
    const data = {
      date: new Date().toISOString().slice(0, 10),
      elastic_id: this.data.idinindex ? this.data.idinindex: this.data.id
    }
    tabName && (data['tabname'] = tabName);
    this.personSearchService.saveProfileView(data).subscribe(); // this code is only used for tracking
  }

  getCompanyInfo(type: string, data: any, event) {
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
    // this.currentCompanyInformation = {}
    let companyData = [];
    let pastCompanyData = data?.company
    if (!pastCompanyData?.website) {
      return;
    }

    if (type == 'past') {

      companyData.push(
        {
          ...(pastCompanyData?.id && { id: pastCompanyData?.id }),
          ...(pastCompanyData?.name && { name: pastCompanyData?.name })
        }
      )
    }

    companyData?.length && this.personSearchService.getCompanyLogoV2(companyData).subscribe((res: any) => {
      if (res.status == 'success' && res.data) {
        let companyDetails = res.data[0]
        if (type == 'past') {
          this.currentCompanyInformation['name'] = companyDetails.name ? companyDetails.name : pastCompanyData.name
          this.currentCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : pastCompanyData?.industry
          this.currentCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : pastCompanyData?.location
          this.currentCompanyInformation['size'] = companyDetails.size ? companyDetails.size : pastCompanyData?.size
          this.currentCompanyInformation['linkedin_url'] = companyDetails.linkedin_url ? companyDetails.linkedin_url : pastCompanyData.linkedin_url
          this.currentCompanyInformation['website'] = companyDetails.website ? companyDetails.website : pastCompanyData.website
          this.currentCompanyInformation['facebook_url'] = companyDetails.facebook_url ? companyDetails.facebook_url : pastCompanyData.facebook_url
          this.currentCompanyInformation['twitter_url'] = companyDetails.twitter_url ? companyDetails.twitter_url : pastCompanyData.twitter_url
        }
        this.currentCompanyInformation['companylogo'] = companyDetails.companylogo
        this.currentCompanyInformation['tags'] = companyDetails.tags
        this.currentCompanyInformation['id'] = companyDetails.id
        this.currentCompanyInformation['key_id'] = companyDetails.id


        //loadn[0].style.display = 'block'
      }
    });


  }


  highlightInfo(data: string, type: 'current_jobtitle' | 'past_jobtitle' | 'location' | 'skill' | 'exp_summary' | 'currentjobtitle' | 'summary' | 'currentcompany' | 'pastcompany' | 'certification', extaInfo = null) {
    let keywords: any
    keywords = _.without(this.highlightkeywords, "AND", "and", "or", "OR", "not", "NOT");
    if (data) {
      const dataForHighlight = data?.trim().toLowerCase().replace(/<.*?>/g, '').replace(/'/g, "");

      let highlightedData = data;
      switch (type) {
        case 'current_jobtitle':
          {
            if (this.data && this.data?.highlight && this.data?.highlight['experience.title.name']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['job_title.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['job_title']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            }
          }
          break;
        case 'past_jobtitle':
          {
            if (this.data && this.data?.highlight && this.data?.highlight['experience.title.name']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['job_title.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['job_title']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            }
          }
          break;
        case 'location':
          {
            if (this.data && this.data?.highlight && this.data?.highlight['location_name']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['location_name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['location_locality']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['location_locality'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['location_name.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['location_name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            }
          }
          break;
        case 'skill':
          {
            if (this.data && this.data?.highlight && this.data?.highlight['skills']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['skills'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['skills.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['skills.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            }
          }
          break;
        case 'exp_summary':
          {
            let finalObj;
            if (extaInfo?.action == 'exp_summary' && extaInfo.dataObj) {
              if (this.data && this.data?.highlight && this.data?.highlight['experience.summary']) {
                const viewMode = extaInfo?.dataObj?.isTruncated ? 'less' : 'all'

                let highlightFound = this.data.highlight['experience.summary'].find((summary: string) => {
                  let formatdata = extaInfo.dataObj.data.join(' ').replace(/<.*?>/g, '').trim().toLowerCase();
                  const tempData = GlobalService.getFormattedParagraph({ text: summary.replace(/<.*?>/g, '').trim().toLowerCase(), viewmode: viewMode });
                  if (tempData.data.join(' ') == formatdata) {
                    return true;
                  }
                });

                finalObj = highlightFound ? GlobalService.getFormattedParagraph({ text: highlightFound, viewmode: viewMode })
                  : extaInfo.dataObj;
              } else {
                finalObj = extaInfo.dataObj;
              }
            } else {
              finalObj = extaInfo.dataObj;
            }
            if (finalObj.data.length <= 1) {
              highlightedData = finalObj.data[0];
            } else {
              highlightedData = "";
              finalObj?.data.forEach(item => {
                highlightedData += `<li>${item}</li>`
              })
              highlightedData = `<ul> ${highlightedData} </ul>`;
            }
          }
          break;
        case 'currentjobtitle':
          {
            if (this.data && this.data?.highlight && this.data?.highlight['experience.title.name']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['job_title.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['job_title']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            }
          }
          break;
        case 'summary':
          {
            if (this.data && this.data?.highlight && this.data?.highlight['experience.summary']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.summary'].find((summary: string) => summary.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['summary']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['summary'].find((summary: string) => summary.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            }
          }
          break;
        case 'currentcompany':
          {
            if (this.data && this.data?.highlight && this.data?.highlight['job_company_name']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['experience.company.name']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            }
          }
          break;

        case 'pastcompany':
          {
            if (this.data && this.data?.highlight && this.data?.highlight['job_company_name']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['experience.company.name']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
              highlightFound && (highlightedData = highlightFound);
            } if (this.data && this.data?.highlight && this.data?.highlight['lastjob_company_name.keyword']) {
              const highlightFound = this.data && this.data?.highlight && this.data?.highlight['lastjob_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').replace(/'/g, "").trim().toLowerCase() === dataForHighlight.replace(/'/g, ""));
              highlightFound && (highlightedData = highlightFound);
            }
          }
          break;
        case 'certification':
          {
            if (this.data && this.data?.highlight) {
              if (this.data?.highlight['certifications.name']) {
                const highlightFound = this.data.highlight['certifications.name'].find((cert: string) => cert.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound);
              }
              if (this.data.highlight['certifications.organization']) {
                const highlightFound = this.data.highlight['certifications.organization'].find((org: string) => org.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound);
              }
            }
          }
      }

      return highlightedData;
      //  }
    }

    return data;
  }

  /**
 * Used to format data in view-more and view-less form
 * @param type i.e. view-more or view-less
 * @param obj  data object
 */
  formatDescription(type: string, obj) {
    if (type == 'view-more') {
      this.data.experience.forEach(item => {
        if (item.index == obj.index) {
          item.formattedExpSummary = GlobalService.getFormattedParagraph({ text: obj.expsummary, viewmode: 'all' });
        }
      })

    } else if (type == 'view-less') {
      this.data.experience.forEach(item => {
        if (item.index == obj.index) {
          item.formattedExpSummary = GlobalService.getFormattedParagraph({ text: obj.expsummary, viewmode: 'less' });
        }
      })
    }
  }

  getsimilarcandidatesData() {
    this.issimilartabshow = false;
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
    this.personSearchService.getdetailsfromlinkedin(this.data.linkedin_url).subscribe((res: any) => {
      if (res.status == "success") {
        if (res.data) {
          const pastindustries = _.pluck(res.data.experience, 'company')
          const schools = _.pluck(res.data.education, 'school')
          const degrees = _.uniq(_.flatten(_.map(res.data.education, 'degrees')));
          const fieldOfStudy = _.uniq(
            _.flatten(
              _.map(res.data.education, 'majors').concat(_.map(res.data.education, 'minors'))
            )
          );
          const locations = []
          const locParts = [];

          res.data.location_locality && locParts.push(res.data.location_locality);
          res.data.location_region && locParts.push(res.data.location_region);
          res.data.location_country && locParts.push(res.data.location_country);

          if (locParts.length) {
            locations.push(locParts.join(', '));
          }

          const totalTenure = res.data.totaltenure || 0;
          let fromYrsOfExperience = 0;
          let toYrsOfExperinece = 0;

          if (!isNaN(totalTenure) && totalTenure >= 0) {
            if (totalTenure > 2) {
              fromYrsOfExperience = Math.floor(totalTenure - 2);
              toYrsOfExperinece = Math.ceil(totalTenure + 2);
            } else {
              fromYrsOfExperience = 0;
              toYrsOfExperinece = Math.ceil(totalTenure + 2);
            }
          }
          const requestObject = {
            startindex: 0,
            resultsize: 10,
            searchviaboolean: true,
            booleanquery: "*",
            jobtitles: [],
            preferredskills: [],
            mandatoryskills: [],
            locations: [],
            companies: [],
            industries: [],
            exclusionlist: [],
            genders: [],
            seniority: [],
            graduationyear: [],
            schools: [],
            schooltypes: [],
            educationaldegrees: [],
            educationalmajors: [],
            candidateshavingemails: false,
            candidateshavingcontactnumbers: false,
            minexperience: null,
            maxexperience: null,
            minexperienceinccurrentcompany: null,
            zipcodes: [],
            companysizes: [],
            candidateshavingcontacts: false,
            workregions: [],
            workcountries: [],
            worklocalities: [],
            spokenlanguages: [],
            contacts: [],
            candidateshavingmobilenumber: false,
            candidateshavingpersonalemail: false,
            candidateshavingprofessionalemail: false,
            candidateshavingsocialprofiles: false,
            fromgraduationyear: [],
            tograduationyear: [],
            exclude_jobtitles: [],
            exclude_companies: [],
            exclude_locations: [],
            fromyearsofexperience: [],
            toyearsofexperience: [],
            likelytomovetype: [],
            salaries: [],
            salaryranges: [],
            continentstobeincluded: res.data.location_continent ? [res.data.location_continent]: [],
            similarcandidates_degrees: degrees ? degrees.map(s => ({ key: s, isMandatory: false })) : [],
            similarcandidates_schools: schools && schools.length ? _.pluck(schools, 'name').map(el => ({key: el, isMandatory: false}) ) : [],
            similarcandidates_fieldofstudy: fieldOfStudy ? fieldOfStudy.map(s => ({ key: s, isMandatory: false })) : [],
            similarcandidates_industries: res.data.job_company_industry ? [{ key: res.data.job_company_industry, isMandatory: true }] : [],
            similarcandidates_locations: _.uniq(locations).map(l => ({ key: l, isMandatory: false })),
            similarcandidates_skills: res.data.skills ? res.data.skills.map(s => ({ key: s, isMandatory: false })) : [],
            similarcandidates_companysizes: res.data.job_company_size ? [{ key: res.data.job_company_size, isMandatory: false }] : [],
            similarcandidates_fromyearsofexperience: [fromYrsOfExperience],
            similarcandidates_toyearsofexperience: [toYrsOfExperinece],
            similarcandidates_totaltenure: res.data.totaltenure,
            similarcandidates_jobtitles: res.data.job_title ? [{ key: res.data.job_title, isMandatory: true }] : [],
            similarcandidates_companies: res.data.job_company_name ? [{ key: res.data.job_company_name, isMandatory: false }] : [],
            exclude_persons: [res.data.id],
            linkedinurl: this.data.linkedin_url,
            isUploadedFromResume: false,
            fullname: res.data.full_name,
            needcuratedtalentpooltags: true
            //  zone: this.localstorageservice.getItem('region')
          }

          if (this.similarCandidateService.isListingCalledFromSimilarCandidate) {
            delete requestObject.needcuratedtalentpooltags;
          }
          this.personSearchService.getPersonSearchRecommendCandidates(requestObject).subscribe(response => {
            if (response.status == "success") {

              this.totalresultcount = response.data.totalresultscount;
              this.similarcandidates = response.data.results;
              this.issimilartabshow = true
              // //loadn[0].style.display = 'block';
              // this.isProfileTabCalled = true;
              const jobLastVerified = response.data.results
              // this.jobLastVerifiedDate = jobLastVerified[0].job_last_verified ? GlobalService.getUpdateDates(jobLastVerified[0].job_last_verified).text : jobLastVerified[0].job_last_verified
            }
          })



        }
      }
    })
  }

  // not in an indian format
  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  ngOnDestroy() {
    this.eventHandler({ data: this.data })
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }


  /**
   * Show all social icons except LinkedIn
   * @returns array of social icons
   */
  getSocialIcons() {
    const uniqueProfiles = this.data?.profiles
      .filter(profile => profile.network !== 'linkedin') // Exclude LinkedIn
      .reduce((acc, profile) => {
        // If network doesn't exist in accumulator, add it
        if (!acc[profile.network]) {
          acc[profile.network] = profile;
        } else {
          // Compare 'last_seen' dates and keep the latest one
          const existingProfile = acc[profile.network];
          if (new Date(profile.last_seen) > new Date(existingProfile.last_seen)) {
            acc[profile.network] = profile;
          }
        }
        return acc;
      }, {});

    //declare the global variable can use in the future
    this.socialIcons = Object.values(uniqueProfiles);

    this.socialIcons.forEach(profile => {
      if (profile.network === 'facebook') {
        this.facebook_url = profile.url;
      } else if (profile.network === 'twitter') {
        this.twitter_url = profile.url;
      } else if (profile.network === 'github') {
        this.github_url = profile.url;
      }
    });
  }

  /**
   * Method to return match category
   * @param matchcategory
   * @returns
   */
  showMatchScore(matchcategory: string) {
    let match = '';

    if (matchcategory == 'EXCELLENT') {
      match = 'Excellent Match';
    } else if (matchcategory == 'GOOD') {
      match = 'Good Match';
    } else if (matchcategory == 'POTENTIAL') {
      match = 'Potential Match';
    } else if (matchcategory == 'NOT_A_MATCH') {
      match = 'Not a Match';
    }

    return match;
  };

  /**
   * Method to copy AI Summary
   * @param content
   */
  copyToClipboard(content: string) {
    let temp = document.createElement('div');
    temp.innerHTML = content;
    let text = temp.textContent || temp.innerText || '';
    text = text.replace(/BULLET:-\s*/g, ' ');

    let inp = document.createElement('input');
    document.body.appendChild(inp);
    inp.value = text;
    inp.select();
    document.execCommand('copy', false);
    inp.remove();
    this.successMessage = 'Copied to clipboard';
    setTimeout(() => this.successMessage = '', 5000);
  };

  /**
   * Method to format AI Summary Text
   * @param text
   */
  formatAISummary(text: string) {
    let cleanedText = text?.replace(/<\/?em>/g, '');

    if (!cleanedText?.includes('BULLET:-')) {
      return cleanedText?.trim();
    }

    const bulletItems = cleanedText?.split('BULLET:-')
      .map(item => item?.trim())
      .filter(item => item.length > 0);

    const listItems = bulletItems.map(item => `<li>${item}</li>`).join('');
    return `<ul>${listItems}</ul>`;

  };

  /**
   * Autopilot export to PDF method
   */
  autpolitCandidateExportToPDF() {
    if(this.autopilotPdfExportInPrgoress) return;
    this.autopilotPdfExportInPrgoress = true;
    const elasticId = this.data.id;
    const calledFrom = 'autopilot';
    const projectnumber = this.route.snapshot.paramMap.get('projectnumber');
    const payload = {
      elasticid: elasticId,
      calledfrom: calledFrom,
      projectdetails: {
        projectnumber: projectnumber
      }
    }
    this.personSearchService.exportCandidateProfileToPDF(payload).subscribe((res: any) => {
      if (res) {
        if (res.status === 'failure') {
          this.errorMessage = 'Error occurred while exporting to PDF';
        }
        else {
          const blobFile = new Blob([res], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blobFile);
          const downloadLink = document.createElement("a");
          downloadLink.style.display = "none";
          document.body.appendChild(downloadLink);
          downloadLink.setAttribute("href", blobUrl);
          downloadLink.setAttribute("download", `${this.data.full_name.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())}.pdf`);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          this.successMessage = 'Exported to PDF successfully';
        }
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
        this.autopilotPdfExportInPrgoress = false;
      }
    }, (err)=>{
      this.autopilotPdfExportInPrgoress = false
    });
  }

  getRevealContactStatus(event) {
    this.revealStatusEventEmitter.emit(event);
  }
}
